// extracted by mini-css-extract-plugin
export default {"modalTitle":"modalTitle___sc8Gd","modalMessage":"modalMessage___HX0Ej","modalButtons":"modalButtons___pSQiw"};